(function () {
  const MOBILE_FORM_ID = 'FacetFiltersFormMobile';

  function patchMobileFacetForm() {
    const form = document.getElementById(MOBILE_FORM_ID);
    if (!form) return;

    const facetForm = form.closest('facet-filters-form');
    if (!facetForm || typeof facetForm.onSubmitHandler !== 'function') return;
    if (facetForm._tkBatchPatched) return;
    facetForm._tkBatchPatched = true;

    const original = facetForm.onSubmitHandler.bind(facetForm);
    facetForm.onSubmitHandler = function (event) {
      if (event && event.type === 'input') return;
      return original(event);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchMobileFacetForm);
  } else {
    patchMobileFacetForm();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      '#' + MOBILE_FORM_ID + ' .mobile-facets__footer button[type="button"]',
    );
    if (!button) return;

    const form = document.getElementById(MOBILE_FORM_ID);
    if (!form) return;

    const facetForm = form.closest('facet-filters-form');
    if (!facetForm || typeof facetForm.onSubmitHandler !== 'function') return;

    const disabled = [];
    form.querySelectorAll('tk-price-range').forEach((priceRange) => {
      if (!priceRange._isPristine) return;
      priceRange.querySelectorAll('.tk-price-range__number').forEach((input) => {
        input.disabled = true;
        disabled.push(input);
      });
    });

    try {
      facetForm.onSubmitHandler(event);
    } finally {
      disabled.forEach((input) => {
        input.disabled = false;
      });
    }

    const drawer = facetForm.closest('menu-drawer');
    const mainSummary = drawer && drawer.querySelector('details > summary');
    if (mainSummary) mainSummary.click();
  });
})();
